import { useSearch } from "@tanstack/react-router";
import { useGetLinkThemesRequest } from "src/services/link/queries/themes";
import palette from "src/theme/palette";
import { AppThemeType } from "src/types/apps";

import { ConnectAccountParams } from "../ConnectAccount/ConnectAccount";

const validateParam = (param: string | undefined, fallback: string): string => {
	return param && param !== "undefined" && param !== "" ? param : fallback;
};

export default function useGetLinkTheme() {
	const {
		id,
		themeType,
		primaryColor,
		backgroundColor,
		contentBackgroundColor
	}: ConnectAccountParams = useSearch({
		strict: false
	});

	const { data } = useGetLinkThemesRequest({ id, type: themeType });

	const isLight = themeType === "light";
	const hasTheme = data && data.id !== null;
	const themePalette = isLight ? palette.light : palette.dark;

	const theme: AppThemeType = {
		type: themeType,
		colors: {
			primary: validateParam(primaryColor, themePalette.primary.main),
			primaryText: themePalette.text.primary,
			secondaryText: themePalette.text.secondary,
			pageBackground: validateParam(backgroundColor, themePalette.background.default),
			contentBackground: validateParam(contentBackgroundColor, themePalette.background.paper),
			buttonBackground: validateParam(primaryColor, themePalette.primary.main),
			buttonText: themePalette.common.white,
			stroke: "#919eab",
			mainError: themePalette.error.main,
			lightError: themePalette.error.lighter,
			darkError: themePalette.error.darker
		},
		button: {
			shape: 8,
			width: "100%",
			textWeight: "BOLD"
		}
	};

	const dataTheme: AppThemeType = {
		...data!,
		colors: {
			...data?.colors!,
			primary: validateParam(primaryColor, data?.colors?.primary ?? ""),
			pageBackground: validateParam(backgroundColor, data?.colors?.pageBackground ?? ""),
			contentBackground: validateParam(
				contentBackgroundColor,
				data?.colors?.contentBackground ?? ""
			),
			buttonBackground: validateParam(primaryColor, data?.colors?.buttonBackground ?? "")
		}
	};

	return { theme: hasTheme ? dataTheme : theme };
}
